import React from 'react';
import { useDispatch } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRightToBracket } from '@fortawesome/free-solid-svg-icons'
import { setModal } from "../redux/modalSlice";

export default function WireApprovalButtons(props) {
  const { id, loanNumber, customerId, loanId, rowStyle } = props
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(
        setModal({
          is_active: true,
          type: 'wire_approval_modal',
          options: { id: id, loanNumber: loanNumber, customerId: customerId, loanId: loanId }
        })
      )
  }
  return (
    <th className={`fixed sticky ${rowStyle}`}>
      <a className="button is-primary" onClick={handleClick} rel="noopener noreferrer">
        <FontAwesomeIcon icon={faRightToBracket} />
      </a>
    </th>
  )
}
